import { useState } from 'react'
import { ModalProps } from '../../types/modal'
import Modal from '../shared/Modal'
import Checkbox from '@components/forms/Checkbox'
import { localStorageKey, useLocalStorage } from 'hooks/useLocalStorageState'
import Button from '@components/shared/Button'
import { useTranslation } from 'next-i18next'

type SideFilter = {
  buy: boolean
  sell: boolean
}
type Side = keyof SideFilter

export const SIDE_FILTER_KEY = localStorageKey('tradeSideFilter-0.3', {
  buy: true,
  sell: true,
} as SideFilter)

const SideFilterFormModal = ({ isOpen, onClose }: ModalProps) => {
  const { t } = useTranslation('trade')
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="mb-4 text-center">{t('filter.title.side')}</h2>
      <SideFilterForm onSave={onClose} />
    </Modal>
  )
}

export default SideFilterFormModal

export const SideFilterForm = ({ onSave }: { onSave: () => void }) => {
  const { t } = useTranslation('trade')
  const [savedForm, setSavedForm] = useLocalStorage(SIDE_FILTER_KEY)
  const [form, setForm] = useState(savedForm)

  const handleFormChange = (side: Side) => {
    setForm((prevState: SideFilter) => ({
      ...prevState,
      [side]: !prevState[side],
    }))
  }

  const handleApplyFilter = () => {
    setSavedForm(form)
    onSave()
  }

  const isValid = form.buy || form.sell

  return (
    <>
      <div className="mb-6 space-y-3">
        <Checkbox checked={form.buy} onChange={() => handleFormChange('buy')}>
          <span className="text-sm">{t('filter.side.buys')}</span>
        </Checkbox>
        <Checkbox checked={form.sell} onChange={() => handleFormChange('sell')}>
          <span className="text-sm">{t('filter.side.sells')}</span>
        </Checkbox>
      </div>
      <div className="flex justify-end">
        <Button onClick={() => handleApplyFilter()} disabled={!isValid}>
          {t('filter.side.apply')}
        </Button>
      </div>
    </>
  )
}
